import ReactGA from "react-ga4";

type AnalyticsEventParams = Record<
  string,
  string | number | boolean | null | undefined
>;

export function trackPageView(path: string) {
  try {
    ReactGA.send({ hitType: "pageview", page: path });
  } catch (error) {
    console.error(error);
  }
}

export function trackEvent(action: string, params?: AnalyticsEventParams) {
  try {
    ReactGA.event(action, params ?? {});
  } catch (error) {
    console.error(error);
  }
}

export function trackBinderCreated(binderId: number, name: string) {
  trackEvent("binder_create", { binder_id: binderId, name });
}

export function trackAddedToBinder(args: {
  binderId: number;
  variantId: number;
  quantity?: number;
  purchasePrice?: number | null;
}) {
  trackEvent("binder_add", {
    binder_id: args.binderId,
    variant_id: args.variantId,
    quantity: args.quantity ?? 1,
    purchase_price: args.purchasePrice ?? null,
  });
}

export function trackAddedToWatchlist(variantId: number, scanned: boolean) {
  trackEvent("watchlist_add", { variant_id: variantId, scanned });
}

export function trackScanStarted(kind: "camera" | "upload") {
  trackEvent("scan_start", { kind });
}
